import { DEFAULT_RECEIPT_TEMPLATE, effectiveOrder, RECEIPT_FOOTER_MAX_LINES, RECEIPT_NARROW_COLUMNS, } from '@aeris/printing';
/**
 * Cópia funda do modelo. Ele é JSON puro (o que o servidor guarda), então a
 * volta por texto basta — e funciona no Hermes do celular, que não garante o
 * `structuredClone`.
 */
const cloneTemplate = (value) => JSON.parse(JSON.stringify(value));
export const PAPER_LABELS = {
    32: 'Bobina 58 mm',
    48: 'Bobina 80 mm',
};
export const DOCUMENT_LABELS = {
    receipt: 'Cupom de venda',
    quote: 'Orçamento',
    exchange: 'Comprovante de troca',
    voucher: 'Comprovante de vale',
    statement: 'Extrato do cliente',
    settlement: 'Recibo de pagamento',
};
export const DOCUMENT_KEYS = [
    'receipt',
    'quote',
    'exchange',
    'voucher',
    'statement',
    'settlement',
];
/**
 * Troca uma linha de lugar com a vizinha — F160.
 *
 * Parte da ordem EFETIVA, e não da gravada: um modelo salvo antes de uma linha
 * existir não a traz, e o papel a imprime no fim. Mover a partir da lista
 * gravada faria a tela e o papel discordarem sobre onde a linha está.
 *
 * Botões de subir e descer, e não arrastar: arrastar não se faz pelo teclado, e
 * o editor é usado no mesmo computador do caixa.
 */
export const moveLine = (order, action) => {
    const lines = [...effectiveOrder(order)];
    const from = lines.indexOf(action.line);
    const to = from + action.by;
    if (from < 0 || to < 0 || to >= lines.length)
        return lines;
    const moved = lines[from];
    const other = lines[to];
    if (moved === undefined || other === undefined)
        return lines;
    lines[from] = other;
    lines[to] = moved;
    return lines;
};
export const emptyDraft = () => cloneTemplate(DEFAULT_RECEIPT_TEMPLATE);
export const draftReducer = (draft, action) => {
    switch (action.type) {
        case 'reset':
            return action.template;
        case 'header':
            return { ...draft, header: { ...draft.header, ...action.patch } };
        case 'lines':
            return { ...draft, lines: { ...draft.lines, ...action.patch } };
        case 'receipt':
            return { ...draft, receipt: { ...draft.receipt, ...action.patch } };
        case 'paper':
            return { ...draft, paper: action.paper };
        case 'font':
            return { ...draft, font: { ...draft.font, ...action.patch } };
        case 'quoteValidity':
            return { ...draft, quoteValidity: action.value };
        case 'customer':
            return { ...draft, customer: { ...draft.customer, ...action.patch } };
        case 'move':
            return { ...draft, infoOrder: moveLine(draft.infoOrder, action) };
        case 'document':
            return {
                ...draft,
                documents: {
                    ...draft.documents,
                    [action.key]: { ...draft.documents[action.key], ...action.patch },
                },
            };
        case 'resetDocument':
            return {
                ...draft,
                documents: {
                    ...draft.documents,
                    [action.key]: cloneTemplate(DEFAULT_RECEIPT_TEMPLATE.documents[action.key]),
                },
            };
        case 'resetAll':
            return emptyDraft();
    }
};
/**
 * O que a pessoa digitou no campo de várias linhas vira lista.
 *
 * Apara as pontas, joga fora linha vazia — senão ela sai em branco no papel — e
 * corta no teto, para o rodapé não empurrar o corte da guilhotina.
 */
export const linesFromText = (text, max = RECEIPT_FOOTER_MAX_LINES) => text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .slice(0, max);
export const textFromLines = (lines) => lines.join('\n');
/** A linha cabe na bobina escolhida? É aviso na tela, não erro do servidor. */
export const overflowsPaper = (text, paper) => text.trim().length > (paper === 32 ? RECEIPT_NARROW_COLUMNS : 48);
export const isDirty = (draft, baseline) => JSON.stringify(draft) !== JSON.stringify(baseline);
//# sourceMappingURL=receipt-template-draft.js.map